import { render, staticRenderFns } from "./rp-users-datasources-list.vue?vue&type=template&id=05428ef9"
import script from "./rp-users-datasources-list.vue?vue&type=script&lang=js"
export * from "./rp-users-datasources-list.vue?vue&type=script&lang=js"
import style0 from "./rp-users-datasources-list.vue?vue&type=style&index=0&id=05428ef9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports